export const EMAIL_REG_EX = /^[a-zA-Z0-9_+-.±]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
export const PASSWORD_REG_EX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/;

export interface RequestState {
  errMsg: string;
  isValid: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isEdited?: boolean;
  isHidden?: boolean;
}
